<template>

    <div class="flex flex-col min-h-full col-span-1 text-center bg-white border divide-y divide-gray-200 shadow-sm rounded-t-2xl">
        <div v-if="isPassed" class="p-2 quiz-pass-ribbon">
            <div class="py-1 text-sm font-semibold text-white bg-sa-red-500 rounded-xl ">
                <i aria-hidden="true" class="mr-1 fas fa-check opacity-80"></i>
                <span>Passed!</span>
            </div>
        </div>
        
        <div class="flex flex-col flex-1 p-8">

            <a :href="`/${quiz.id}/${quiz.slug}`" 
               :alt="quiz.title"
               :title="quiz.title" 
               class="text-lg font-medium text-gray-900 hover:underline hover:decoration-cyan-500 hover:transition-all hover:decoration-2">
                <h3 class="">{{quiz.title}}</h3>
            </a>
            <dl class="flex flex-col justify-between flex-grow mt-1">
                <dt class="sr-only">Description</dt>

                <dd class="text-sm text-clay-800">{{quiz.description}}</dd>

                <dt class="sr-only">Guide Type</dt>
                <dd class="items-center mt-3 text-center">
                    <span v-if="quiz.hasAssociatedShowGuides" 
                          class="inline-flex inline-flex px-2 py-1 m-1 mb-2 text-xs font-medium border rounded-full text-electric-700 bg-electric-50 hover:border-electric-500 hover:border">Shows</span>

                    <span v-if="quiz.hasAssociatedAuthorGuides" 
                          class="inline-flex inline-flex px-2 py-1 m-1 mb-2 text-xs font-medium border rounded-full text-electric-700 bg-electric-50 hover:border-electric-500 hover:border">Writers</span>
                    
                    <span v-if="!quiz.hasAssociatedGuides" 
                          class="inline-flex inline-flex px-2 py-1 m-1 mb-2 text-xs font-medium border rounded-full text-electric-700 bg-electric-50 hover:border-electric-500 hover:border">General Theatre</span>
                </dd>
            </dl>
        </div>
        <div  v-if="quiz.difficultyLevelIndicator === 'beginner'" class="bg-gradient-to-b from-green-200">
            <div class="flex -mt-px divide-x divide-gray-200 ">
                <div class="flex flex-1 w-0">
                    <div class="relative inline-flex items-center justify-center flex-1 w-0 py-2 -mr-px text-xs font-medium text-gray-700 border border-transparent rounded-bl-lg ">
                        <div>
                            <div
                               class=" font-small" style="font-size: 0.85rem">
                                Level:
                                <BoltIconSolid class="inline-block w-4 h-4"></BoltIconSolid>
                                <BoltIconOutline class="inline-block w-4 h-4"></BoltIconOutline>
                                <BoltIconOutline class="inline-block w-4 h-4"></BoltIconOutline>
                            </div>
                         

                        </div>
                    </div>

                </div>
                <div class="flex flex-1 w-0 -ml-px">
                    <div class="relative inline-flex items-center justify-center flex-1 w-0 px-3 py-2 text-xs font-medium text-gray-700 border border-transparent rounded-br-lg ">
                        <span class="w-full px-2 py-2 font-bold">{{quiz.points}} points</span>
                    </div>
                </div>
            </div>
            <div class="flex -mt-px divide-x divide-gray-200 ">
                <div class="flex flex-1 w-0 px-3 py-2">
                    <a class="relative inline-flex items-center justify-center flex-1 w-0 py-2 -mr-px font-medium text-white border border-transparent rounded-md shadow-sm bg-clay-800 hover:bg-clay-800 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-clay-500"
                       :href="`/${quiz.id}/${quiz.slug}`" >
                        <span class="start-quiz">Start Quiz</span>
                    </a>
                </div>

            </div>
        </div>
        <div v-if="quiz.difficultyLevelIndicator === 'intermediate'" class="bg-gradient-to-b from-amber-200">
            <div class="flex -mt-px divide-x divide-gray-200">
                <div class="flex flex-1 w-0">
                    <div class="relative inline-flex items-center justify-center flex-1 w-0 py-2 -mr-px text-xs font-medium text-gray-700 border border-transparent rounded-bl-lg ">
                        <div>
                         
                            <div 
                               class=" for-level-intermediate font-small" style="font-size: 0.85rem">
                                Level:
                                <BoltIconSolid class="inline-block w-4 h-4"></BoltIconSolid>
                                <BoltIconSolid class="inline-block w-4 h-4"></BoltIconSolid>
                                <BoltIconOutline class="inline-block w-4 h-4"></BoltIconOutline>
                            </div>
                            

                        </div>
                    </div>

                </div>
                <div class="flex flex-1 w-0 -ml-px">
                    <div class="relative inline-flex items-center justify-center flex-1 w-0 px-3 py-2 text-xs font-medium text-gray-700 border border-transparent rounded-br-lg ">
                        <span class="w-full px-2 py-2 font-bold">{{quiz.points}} points</span>
                    </div>
                </div>
            </div>
            <div class="flex -mt-px divide-x divide-gray-200 ">
                <div class="flex flex-1 w-0 px-3 py-2">
                    <a class="relative inline-flex items-center justify-center flex-1 w-0 py-2 -mr-px font-medium text-white border border-transparent rounded-md shadow-sm bg-clay-800 hover:bg-clay-800 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-clay-500"
                       :href="`/${quiz.id}/${quiz.slug}`" >
                        <span class="start-quiz">Start Quiz</span>
                    </a>
                </div>

            </div>
        </div>
        <div  v-if="quiz.difficultyLevelIndicator === 'advanced'" class="bg-gradient-to-b from-rose-200" >
            <div class="flex -mt-px divide-x divide-gray-200 ">
                <div class="flex flex-1 w-0">
                    <div class="relative inline-flex items-center justify-center flex-1 w-0 py-2 -mr-px text-xs font-medium text-gray-700 border border-transparent rounded-bl-lg ">
                        <div>
                           
                            <div 
                               class="for-level-advanced font-small " style="font-size: 0.85rem">
                                Level:
                                <BoltIconSolid class="inline-block w-4 h-4"></BoltIconSolid>
                                <BoltIconSolid class="inline-block w-4 h-4"></BoltIconSolid>
                                <BoltIconSolid class="inline-block w-4 h-4"></BoltIconSolid>
                            </div>

                        </div>
                    </div>

                </div>
                <div class="flex flex-1 w-0 -ml-px">
                    <div class="relative inline-flex items-center justify-center flex-1 w-0 px-3 py-2 text-xs font-medium text-gray-700 border border-transparent rounded-br-lg ">
                        <span class="w-full px-2 py-2 font-bold">{{quiz.points}} points</span>
                    </div>
                </div>
            </div>
            <div class="flex -mt-px divide-x divide-gray-200 ">
                <div class="flex flex-1 w-0 px-3 py-2">
                    <a class="relative inline-flex items-center justify-center flex-1 w-0 py-2 -mr-px font-medium text-white border border-transparent rounded-md shadow-sm bg-clay-800 hover:bg-clay-800 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-clay-500"
                       :href="`/${quiz.id}/${quiz.slug}`" >
                        <span class="start-quiz">Start Quiz</span>
                    </a>
                </div>

            </div>
        </div>
    </div>

</template>

<script lang="ts" setup>
// @ts-ignore
import {defineProps, onMounted, ref} from "vue";
import {store} from "@/store";
import {QuizDTO} from "@/dtos";
import {BoltIcon as BoltIconSolid} from '@heroicons/vue/24/solid';
import {BoltIcon as BoltIconOutline} from '@heroicons/vue/24/outline';

const props = defineProps({
    quiz: {},
})

const quiz: QuizDTO = props.quiz;
let isPassed: boolean = ref(false);

onMounted((): void => {
    if (store.saUserSession.completedQuizItems.includes(quiz.id.toLowerCase())) {
        isPassed = true;
    }
});
</script>